import { JsonProperty, JsonObject } from "typescript-json-serializer";
import { OcmfTransactionReading } from "./ocmf-transaction-reading.model";

@JsonObject()
export class OcmfTransaction {
    @JsonProperty('FV') formatVersion: string;
    @JsonProperty('GI') gatewayIdentification: string;
    @JsonProperty('GS') gatewaySerial: string;
    @JsonProperty('GV') gatewayVersion: string;
    @JsonProperty('PG') paginationCounter: string;
    @JsonProperty('IS') identificationStatus: boolean;
    @JsonProperty('IL') identificationLevel: string;
    @JsonProperty('IF') identificationFlags: string[];
    @JsonProperty('IT') identificationType: string;
    @JsonProperty('ID') identificationData: string;
    @JsonProperty('RD') readings: OcmfTransactionReading[];
}